import { IInitialState } from './models';
import admin from '../modules/admin-panel/store';
import { InitialSurveyReducer } from '../modules/survey/survey.reducer';

const InitialState: IInitialState = {
	admin,
	survey: InitialSurveyReducer,
};

export default InitialState;
